import { createIcon } from "@chakra-ui/icons";

export const LiveDisabledIcon = createIcon({
  displayName: "LiveDisabled",
  viewBox: "0 0 19 19",
  path: (
    <g>
      <path
        d="M9.5 0.75C14.3322 0.75 18.25 4.66784 18.25 9.5C18.25 14.3322 14.3322 18.25 9.5 18.25C4.66784 18.25 0.75 14.3322 0.75 9.5C0.75 4.66784 4.66784 0.75 9.5 0.75Z"
        stroke="#A6A6A6"
        fill="none"
      />
      <path d="M7.125 14.2428V4.75708L14.25 9.49996L7.125 14.2428Z" fill="#A6A6A6" />
    </g>
  ),
});
